import { TYPE } from '@/constants';
import { Section } from '../models/sections/section';

/* eslint-disable no-plusplus */
export function hypotenuse({ x, y, x2, y2 }) {
  return Math.hypot(x2 - x, y2 - y);
}

export function getAngle({ x, y, x2, y2 }, radians = false) {
  const dx = x2 - x;
  const dy = y2 - y;
  let theta = Math.atan2(dy, dx);
  if (radians) return theta;
  theta *= 180 / Math.PI;

  return theta < 0 ? 360 + theta : theta;
}

export function getAngleDxDy(dx, dy, radians = false) {
  let theta = Math.atan2(dy, dx);
  if (radians) return theta;
  theta *= 180 / Math.PI;

  return theta < 0 ? 360 + theta : theta;
}

export function hypotenuseDxDy(dx, dy) {
  return Math.hypot(dx, dy);
}

export function getQuarter(angleInDeg) {
  if (angleInDeg > 0 && angleInDeg <= 90) return [1, 1];
  if (angleInDeg > 90 && angleInDeg <= 180) return [-1, 1];
  if (angleInDeg > 180 && angleInDeg <= 270) return [-1, -1];
  if (angleInDeg > 270 && angleInDeg <= 360) return [1, -1];

  return [1, 1];
}

export function flipMatrix(angle, x, y) {
  const tm = { a: 1, b: 0, c: 0, d: 1, e: x * 2, f: y * 2 };
  if (angle > 90 && angle < 180) {
    tm.a = -1;
    tm.f = 0;
  } else if (angle >= 180 && angle <= 270) {
    tm.a = -1;
    tm.d = -1;
  } else if (angle > 270 && angle <= 360) {
    tm.d = -1;
    tm.e = 0;
  } else {
    tm.e = 0;
    tm.f = 0;
  }

  return tm;
}

export function calculateTheGap(gap, count) {
  return gap * count;
}

export function fillTheGaps(gap, count = 1) {
  const precalculations = [];
  while (count--) {
    precalculations.unshift(calculateTheGap(gap, count));
  }
  return precalculations;
}

export const pointInPolygon = (point, polygon) => {
  let inside = false;
  const [x, y] = point;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];

    const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) {
      inside = !inside;
    }
  }

  return inside;
};

/**
 * @param {import('../models').Section} section
 * @param {import('../models').Unit[]} units
 * @returns {import('../models').Unit[]}
 */
export const getUnitsInSection = (section, units) => {
  switch (section.subtype) {
    case TYPE.RECT: {
      const sectionBBox = section.shape.bbox();
      return units.filter((u) => {
        const [x, y] = u.attributes.position;

        if (x >= sectionBBox.x && x <= sectionBBox.x2 && y >= sectionBBox.y && y <= sectionBBox.y2) {
          return true;
        }
      });
    }
    case TYPE.CIRCLE: {
      const { radius, position } = section.attributes;

      const [cx, cy] = position;

      return units.filter((u) => {
        const [x, y] = u.attributes.position;

        // check if x, y in circle
        const dx = x - cx;
        const dy = y - cy;
        const distance = Math.sqrt(dx * dx + dy * dy);

        return distance <= radius;
      });
    }
    case TYPE.POLYGON: {
      const { points } = section.attributes;

      const actualPoints = points.value
        .filter((segment) => segment[0] !== 'z' && segment[0] !== 'Z')
        .map((segment) => {
          return [segment[1], segment[2]];
        });

      return units.filter((u) => {
        const [x, y] = u.attributes.position;

        return pointInPolygon([x, y], actualPoints);
      });
    }
  }
};

export const preloadThumbnail = (id, app) => {
  const { thumbnail } = app.props.sectionPreviews?.find((s) => s.id == id) ?? {};
  if (thumbnail) {
    new Image().src = thumbnail;
  }
};
